import { render, staticRenderFns } from "./ComposerDialog.vue?vue&type=template&id=bd65cc6c&scoped=true&"
import script from "./ComposerDialog.vue?vue&type=script&lang=js&"
export * from "./ComposerDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComposerDialog.vue?vue&type=style&index=0&id=bd65cc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd65cc6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDialog,VRow,VTab,VTabItem,VTabs,VTabsItems,VToolbar})
